import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Checkbox } from 'components/ui';
import { EMAIL_SERVICES } from '../../../constants/common';

const ToggleMultiMode = ({ showRegardless }) => {
  const { watch, setValue, trigger } = useFormContext();

  const forceChoose = watch('force_choose');
  const isMultiMode = watch('isMultiMode');

  const onToggleMultiMode = e => {
    setValue('isMultiMode', e.target.checked);
    trigger('templateId');
    trigger('senderEmail');
    trigger('senderName');
  };

  if (
    showRegardless ||
    [
      EMAIL_SERVICES.SENDGRID,
      EMAIL_SERVICES.GMAIL,
      EMAIL_SERVICES.MICROSOFT,
    ].includes(forceChoose)
  ) {
    return (
      <section className="send-mail-form__section">
        <div>
          <Checkbox checked={isMultiMode} onChange={onToggleMultiMode}>
            Multi Campaign Mode
          </Checkbox>
        </div>
      </section>
    );
  }

  return <></>;
};

export default ToggleMultiMode;
